import React, { Component } from "react";
import i18n from "../i18n";

class NotFoundContainer extends Component {
  render() {
    const lang = i18n.language;
    return (
      <div className="not-found-container text-center">
        <h1>Happens to the best of us</h1>
        <div className="not-found-image"></div>
        <p>Sorry, something seems to have gone wrong.</p>
        <a href={"/" + lang + "/"} className="primary-button">Home</a>
      </div>
    );
  }
}

export default NotFoundContainer;
